import React, { useState } from "react";
import styled from "styled-components";
import { format } from "date-fns";
import { ko } from "date-fns/locale";
import BidsInfo from "./BidsInfo";

const Button = styled.a`
  padding: 8px 3px;
  margin: 6px;
  font-size: 14px;
  color: white;
  background-color: #007BFF;
  border: none;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #0056b3;
  }
`;

const SubTh = styled.th`
  background-color: gray;
  color: white;
  border: 1px solid #ddd;
  padding: 10px 5px;
  text-align: left;
`;

const Td = styled.td`
  border: 1px solid #ddd;
  padding: 10px;
  text-align: left;
`;

const formatPGTime = (timeString) => {
  const date = new Date(timeString);
  return format(date, "yyyy-MM-dd HH:mm:ss", { locale: ko });
};

const statusDisplay = (status) => {
  switch (status) {
    case "public_reaction":
      return "재경매";
    case "public_action":
      return "경매";
    case "reassigned":
      return "재할당";
    case "canceled":
      return "취소";
    case "assigned":
      return "할당";
    case "requested":
      return "요청 중";
    case "awarded":
      return "낙찰됨";
    case "last_action":
        return "마감경매";
    case "last_awarded":
        return "마감 낙찰됨";
    case "completed":
      return "대행완료";
    default:
      return status;
  }
};


export default function OrderHistory({ orderHistories }) {
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [bidData, setBidData] = useState({});




  const toggleExpandRow = async (publicOrderIdStr) => {
    const public_order_id = String(publicOrderIdStr);
  
    if (expandedRowId === public_order_id) {
      setExpandedRowId(null);
    } else {
      if (!bidData[public_order_id]) {
        try {
          const response = await fetch(
            `/Acution/bidsHist/${public_order_id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
  
          console.log('API response status:', response.status);
  
          const responseText = await response.text();
          console.log('Response text:', responseText);
  
          if (!response.ok) {
            console.error(`Error fetching bid data: ${response.statusText}`);
            setBidData((prevBidData) => ({
              ...prevBidData,
              [public_order_id]: [],
            }));
          } else {
            const contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
              const data = JSON.parse(responseText);
              // console.log('Fetched bid data:', data);
              setBidData((prevBidData) => ({
                ...prevBidData,
                [public_order_id]: data,
              }));
            } else {
              console.error('Unexpected content type:', contentType);
              console.error('Response text:', responseText);
              setBidData((prevBidData) => ({
                ...prevBidData,
                [public_order_id]: [],
              }));
            }
          }
        } catch (error) {
          console.error("Error fetching bid data:", error);
          setBidData((prevBidData) => ({
            ...prevBidData,
            [public_order_id]: [],
          }));
        }
      }
      setExpandedRowId(public_order_id);
    }
  };

  const isAuctionStatus = (status) => {
    return status === "public_action" || status === "public_reaction"|| status === "last_action";
  };

  return (
    <React.Fragment>
      {/* {JSON.stringify(orderHistories)} */}
      {orderHistories?.length > 0 ? (
        <table>
          <thead>
            <tr>
              <SubTh>주문 ID</SubTh>
              <SubTh>경매 ID</SubTh>
              <SubTh>이벤트 순서</SubTh>
              <SubTh>대행자</SubTh>
              <SubTh>변경 전</SubTh>
              <SubTh>{`=>`}</SubTh>
              <SubTh>변경 후</SubTh>
              <SubTh>시간</SubTh>
              <SubTh>설정시간</SubTh>
              <SubTh>입찰정보</SubTh>
              {/* <SubTh>테스트</SubTh> */}
            </tr>
          </thead>
          <tbody>
             {orderHistories.map((history, index) => (
              <React.Fragment key={index}>
                <tr>
                  <Td>{history.order_id}</Td>
                  <Td>{history.public_order_id}</Td>
                  <Td>{history.issue_cnt}</Td>
                  <Td>{history.agent}</Td>
                  <Td>{statusDisplay(history.before_change_status)}</Td>
                  <Td>{`=>`}</Td>
                  <Td>{statusDisplay(history.after_change_status)}</Td>
                  <Td>{formatPGTime(history.created_at)}</Td>
                  <Td>{history.duration}분</Td>
                  <Td>
                  {isAuctionStatus(history.after_change_status) && history.public_order_id && (
                      <Button onClick={() => toggleExpandRow(history.public_order_id)}>
                        입찰정보
                      </Button>
                    )}
                  </Td>
                  {/* <Td>{JSON.stringify(history)}</Td> */}
                </tr>
                {expandedRowId === history.public_order_id &&
                  isAuctionStatus(history.after_change_status) && (
                    <tr>
                      <td colSpan="11">
                        <BidsInfo
                        bidData={bidData}
                          bidInfo={
                            bidData[String(history.public_order_id)] || []
                          }
                        />
                      </td>
                    </tr>
                  )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <p>데이터가 없습니다.</p>
      )}
    </React.Fragment>
  );
}

